<template>
  <form-request
    v-if="src"
    :action="src"
    method="post"
    v-slot="{ update, submit, errors }"
  >
    <popup-form
      title="Adjust Package"
      button="Adjust"
      :show="show"
      @close="$emit('close')"
      @confirm="adjustPackage(update, submit)"
    >
      <p class="mb-4"><strong>Note: </strong>If you adjust quantity at source, please refresh page after adjusting.</p>
      <div class="input-group col-span-12 sm:col-span-4 mb-4">
        <label>Location to Adjust:</label>
        <select
          v-model="form.location_id"
          name="location_id"
        >
          <template v-for="location in locations">
            <option hidden>Select Location</option>
            <option :value="location.id">{{ location.name }}</option>
          </template>
        </select>
        <error
          :errors="errors"
          name="location_id"
        />
      </div>

      <div class="input-group col-span-12 sm:col-span-4 mb-4">
        <label>Space:</label>
        <select
          v-model="form.space_id"
          name="space_id"
        >
          <option :value="null">Select a Space</option>
          <template v-for="space in spaceList">
            <option :value="space.id">{{ space.name }}</option>
          </template>
        </select>
        <error
          :errors="errors"
          name="space_id"
        />
      </div>

      <div class="input-group col-span-12 sm:col-span-4 mb-4">
        <label>Sub-Lot:</label>
        <select
          v-model="form.sub_lot_num"
          name="sub_lot_num"
        >
          <option :value="null">Select Sub-Lot</option>
          <template v-for="val in subLotNums">
            <option :value="val">{{ val }}</option>
          </template>
        </select>
        <error
          :errors="errors"
          name="sub_lot_num"
        />
      </div>

      <div class="input-group col-span-12 sm:col-span-4 mb-4">
        <label>Type:</label>
        <select
          v-model="form.type"
          name="type"
        >
          <option value="adjustment">On-Hand & Available</option>
          <option
            v-if="isCompanyAdmin || isCompanyInventory"
            value="adjustment_available"
          >
            Available
          </option>
          <option value="adjustment_on_hand">On-Hand</option>
        </select>
        <error
          :errors="errors"
          name="type"
        />
      </div>

      <div class="input-group col-span-12 sm:col-span-4 mb-4">
        <label>Amount:</label>
        <input
          type="number"
          step="1"
          name="amount"
          v-model="form.amount"
        />
        <error
          :errors="errors"
          name="amount"
        />
      </div>

      <div class="input-group col-span-12 sm:col-span-4 mb-4">
        <label>Reason:</label>
        <select
          v-model="form.reason"
          name="reason"
        >
          <option :value="null">Reason</option>
          <template v-for="val in adjustmentReasons">
            <option :value="val.name">{{ val.name }}</option>
          </template>
        </select>
        <error
          :errors="errors"
          name="reason"
        />
      </div>
      <!--            <div class="input-group col-span-12 sm:col-span-4">-->
      <!--                <textarea type="text" name="reason" rows="3" v-model="form.reason" placeholder="Reason for adjustment..."></textarea>-->
      <!--                <error :errors="errors" name="reason"/>-->
      <!--            </div>-->
    </popup-form>
  </form-request>
</template>

<script>
import PopupForm from '@/Components/Forms/PopupForm'
import FormRequest from '@/Components/Forms/FormRequest'
import Error from '@/Components/Forms/Error'
import accessesCompany from '@/Mixins/accessesCompany'
import hasAuth from '@/Mixins/hasAuth'
import { getHeadersWithToken } from '@/utils/http'

export default {
  mixins: [accessesCompany, hasAuth],
  emits: ['close'],

  components: { PopupForm, FormRequest, Error },
  props: {
    /**
     * If true we display the form
     */
    show: {
      type: Boolean,
      default: false
    },
    package: {
      type: Object,
      required: true
    },
    /**
     * A list of locations we can transfer a package to
     */
    locations: {
      type: Array,
      default() {
        return []
      }
    },
    /**
     * A list of locations we can transfer a package to
     */
    spaces: {
      type: Array,
      default() {
        return []
      }
    },
    /**
     * The route to send the transfer request to. If null we can't send a package and thus don't show the form
     */
    src: {
      type: String,
      default: null
    },
    adjustmentReasons: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      // The form that gets submitted to the server
      form: {
        location_id: null,
        space_id: null,
        sub_lot_num: null,
        type: 'adjustment',
        amount: 0,
        reason: ''
      },
      subLotNums: []
    }
  },

  watch: {
    'form.location_id'(newValue) {
      this.form.space_id = null
      this.fetchSubLotOptions()
    }
  },

  computed: {
    /**
     * Returns a list of locations with a default value at the beginning
     */
    locationList() {
      return [{ name: 'Select Location', id: null }, ...this.locations]
    },
    spaceList() {
      if (!this.form.location_id) {
        return []
      }

      return this.spaces.filter((space) => space.location_id === this.form.location_id)
    }
  },

  methods: {
    async fetchSubLotOptions() {
      console.log('fetching sub-lot nums', { packages: [this.package.id], location_id: this.form.location_id })

      const response = await fetch(
        route('api.packages.sub_lot_options', { packages: [this.package.id], location_id: this.form.location_id }),
        {
          headers: getHeadersWithToken(),
          method: 'get'
        }
      )

      let options = await response.json()
      this.subLotNums = options[this.package.id] || []
    },
    /**
     * Submits transfer request to the server
     * @param update a function (passed by form-request) that sets the values to send to the server
     * @param submit a function (passed by form-request) that submits the form
     */
    adjustPackage(update, submit) {
      this.$emit('close')
      update({ ...this.form })
      submit()
    }
  }
}
</script>
